import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const Bell = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.29 17.373c.568-.062 1.048-.084 1.466-.103 1.121-.05 1.798-.082 2.54-.808.364-.336.599-.786.664-1.272a1.617 1.617 0 0 0-.408-1.477 1.836 1.836 0 0 0-1.25-.534.935.935 0 0 1-.57-.302.9.9 0 0 1-.231-.593v-.527a6.326 6.326 0 0 0-1.106-4.468 6.558 6.558 0 0 0-3.87-2.6c.088-1.296-.12-1.704-1.514-1.689-1.386 0-1.563.401-1.53 1.673a6.566 6.566 0 0 0-3.868 2.601 6.334 6.334 0 0 0-1.108 4.468v.526a.901.901 0 0 1-.23.594.935.935 0 0 1-.571.301 1.72 1.72 0 0 0-.733.158c-.229.105-.43.26-.59.452a1.644 1.644 0 0 0-.344 1.393c.066.487.3.936.665 1.272.818.777 1.99.82 3.094.86.313.012.62.024.912.051.866.063 7.692.063 8.581.024ZM13.25 7.125a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Z"
    />
    <Path
      d="M13.127 19.203a.638.638 0 0 1 .319.049.6.6 0 0 1 .247.196.553.553 0 0 1 .04.586 1.927 1.927 0 0 1-.728.707C12.7 20.91 12.353 21 12 21s-.702-.09-1.007-.26a1.928 1.928 0 0 1-.728-.706.546.546 0 0 1 .045-.582.599.599 0 0 1 .245-.194.637.637 0 0 1 .316-.049c.298 0 .68.035 1.14.035.462 0 .813 0 1.117-.04Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export default Bell;
